import { IconTrash } from "@tabler/icons-react"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { ActionIcon, DateCell, TextCell } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import { type FindFaqByLanguageResponseDto, useDeleteFaq } from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

const columnHelper = createColumnHelper<FindFaqByLanguageResponseDto>()
export const useColumns = (): ColumnDef<FindFaqByLanguageResponseDto>[] => {
  const { t } = useTranslation("admin")
  return useMemo<ColumnDef<FindFaqByLanguageResponseDto, any>[]>(
    () => [
      columnHelper.accessor("createdAt", {
        header: t("columns.createdAt"),
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
      }),
      columnHelper.accessor("updatedAt", {
        header: t("columns.updatedAt"),
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
      }),
      columnHelper.accessor("lang", {
        header: t("columns.lang"),
        cell: (info) => <TextCell value={info.getValue()} />,
      }),
      columnHelper.accessor("question", {
        header: t("columns.question"),
        cell: (info) => <TextCell value={info.getValue()} />,
      }),
      columnHelper.display({
        id: "action-cell-delete",
        header: undefined,
        cell: (info) => <DeleteFaq id={info.row.original.id} />,
      }),
    ],
    [t]
  )
}

const DeleteFaq = ({ id }: { id: string }) => {
  const { mutate: deleteFAQ } = useDeleteFaq({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) =>
            (query.queryKey[0] as { url?: string } | undefined)?.url ===
            "/v1/faq/:lang",
        })
        showSuccessNotification({
          title: "FAQ deleted",
          message: "FAQ deleted successfully",
        })
      },
      onError: (error) => {
        showAxiosError({
          error,
          defaultMessage: "Error deleting FAQ",
          showNotification: true,
        })
      },
    },
  })
  return (
    <ActionIcon
      icon={<IconTrash size={16} />}
      onClick={(event) => {
        event.stopPropagation()
        deleteFAQ({ id })
      }}
    />
  )
}
